<div class="container" *ngIf="finishedLoadingUsers">
    <div class="row marginBottom2Rem">
        <div class="offset-lg-12">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Haushalt von {{this.currentUser?.person?.displayName}}</mat-card-title>
                </mat-card-header>

            </mat-card>



            <div class="row">
                <div class="col-sm-12">
                    <div class="example-container mat-elevation-z2">
                        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                            <ng-container matColumnDef="number">
                                <th mat-header-cell *matHeaderCellDef>
                                    #
                                </th>
                                <td mat-cell *matCellDef="let card; let i = index;" class="mat-column">
                                    {{i+1}}
                                </td>
                            </ng-container>


                            <ng-container matColumnDef="type">
                                <th mat-header-cell *matHeaderCellDef>
                                    Vertragstyp
                                </th>
                                <td mat-cell *matCellDef="let user" class="mat-column">
                
                                    @if (this.currentUser.publicId == user.publicId) {                               
                                        <mat-chip class="primaryChip" selected >
                                       Hauptkunde
                                        </mat-chip>
                      
                                    }@else {
                                        <mat-chip disabled>
                                            Haushaltsmitglied
                                        </mat-chip>
                                    }
                                </td>
                            </ng-container>


                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef>
                                    Haushaltsmitglied
                                </th>
                                <td mat-cell *matCellDef="let user" class="mat-column">
                                    {{user.person.displayName}}
                                </td>
                            </ng-container>



                            <ng-container matColumnDef="state">
                                <th mat-header-cell *matHeaderCellDef>
                                    Status
                                </th>
                                <td mat-cell *matCellDef="let user" class="mat-column">
                                  

                                    <mat-chip-set>
                                        <mat-chip class="primaryChip" selected *ngIf="user.account.state == 'ACTIVE' ">
                                            {{user.account.state | translateState}}
                                        </mat-chip>
                                        <mat-chip disabled *ngIf="user.account.state != 'ACTIVE' ">
                                            {{user.account.state | translateState}}
                                        </mat-chip>
                                    </mat-chip-set>

                                </td>
                            </ng-container>



                            <ng-container matColumnDef="menu">
                                <th mat-header-cell *matHeaderCellDef>
                                    Aktion
                                </th>
                                <td mat-cell *matCellDef="let user">
                                    <button mat-icon-button style="margin: 0 auto !important;"
                                        [matMenuTriggerFor]="menu" color="accent">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #menu="matMenu" >
                                        <button mat-menu-item (click)="moveToMainCustomer(user)">
                                            <span> Hauptkunde werden </span>
                                        </button>
                                        <button mat-menu-item (click)="moveCustomer(user)">
                                            <span> Umziehen </span>
                                        </button>
                                        <button mat-menu-item (click)="createNewOwnGroup(user)">
                                            <span> Eigenen Haushalt gründen </span>
                                        </button>
                                    </mat-menu>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index"></tr>
                        </table>
                        <span *ngIf="dataSource?.data.length === 0" class="emptyTableState  mat-elevation-z2">
                            Keine passenden Einträge gefunden...
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container" *ngIf="!finishedLoadingUsers">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>